import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { ApiWave } from "@/generated/models/ApiWave";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
export default function WaveAuthor(t0) {
  const $ = _c(12);
  const {
    wave
  } = t0;
  const t1 = `/${wave.author.handle}`;
  let t2;
  if ($[0] !== wave.author.handle || $[1] !== wave.author.pfp) {
    t2 = wave.author.pfp ? <img className="tw-h-5 tw-w-5 tw-rounded-md tw-bg-iron-800" src={getScaledImageUri(wave.author.pfp, ImageScale.W_AUTO_H_50)} alt={`${wave.author.handle}`} /> : <div className="tw-h-5 tw-w-5 tw-rounded-md tw-bg-iron-800" />;
    $[0] = wave.author.handle;
    $[1] = wave.author.pfp;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = wave.author.handle ?? wave.author.id;
  let t4;
  if ($[3] !== wave.author.handle) {
    t4 = <span className="tw-text-sm tw-font-medium">{wave.author.handle}</span>;
    $[3] = wave.author.handle;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <UserProfileTooltipWrapper user={t3} placement="left">{t4}</UserProfileTooltipWrapper>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t5) {
    t6 = <div className="tw-flex tw-items-center tw-gap-x-1.5"><Link href={t1} className="tw-flex tw-items-center tw-gap-x-1.5 tw-text-iron-50 tw-no-underline tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-text-iron-200 desktop-hover:hover:tw-underline">{t2}{t5}</Link></div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}